import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import Select from 'react-select';
import Swal from 'sweetalert2';
import endpoints from '../../../config/endpoints';
import { popupSlice } from "../../../services/reducers";
import { setLoading } from '../../../services/reducers/homeSlice';
import restApi from '../../../services/restApi';
import { useAppSelector } from '../../../services/store';
import alertHandler from '../../../utils/alertHandler';
import tools from '../../../utils/tools';
import LoadingBody from '../../App/loading/LoadingBody';

const BuyReport = ({ orderProduct, fetchData = () => {} }) =>{
  const dispatch: any = useDispatch()
  const [isloading, setIsloading] = useState(false);
  const [buyStatus, setBuyStatus] = useState(0);
  const [description, setDescription] = useState('');

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.orderProduct.buy + orderProduct.id, true).post({
      buyStatus: buyStatus,
      description: description,
    })

    alertHandler(res, 'گزارش با موفقیت ذخیره شد', () => {
      fetchData()
      dispatch(popupSlice.hide())
    })

    dispatch(setLoading(false));
  };

  if (isloading){
    return (
      <main className="billBody">
        <LoadingBody/>
      </main>
    )
  }

  return(
    <main className="billMain billSec heightAuto">
    <span className="blueText billHeader">
      جزئیات صورتحساب
    </span>
    <span className="billDetSpan fontSize">
      <p className="textAlignRight">  {Number(orderProduct?.count)} عدد </p>
      <p className="blueText">{tools.formatPrice(orderProduct?.product?.title)}</p>
    </span>
      <div className="billForm">
    <span className="billFormSpan">
      <select className="billInput width63" onChange={e => setBuyStatus(Number(e.target.value))}>
        <option value={0}>انتخاب کنید</option>
        <option value={1}>خریداری شد</option>
        <option value={2}>درخواست مبلغ بیشتر</option>
        <option value={3}>موجود نیست</option>
      </select>
      <p className="blueText">وضعیت</p>
    </span>
    <span className="billFormSpan">
      <textarea rows={3} onChange={(input) => setDescription(input.target.value)} >{description}</textarea>
      <p className="blueText">توضیحات</p>
    </span>
    </div>
    <span className="billButtons">
      <button className="billButton dashboardHeader" onClick={send}>ثبت گزارش</button>
      <button className="billButton cancelButton" onClick={() => dispatch(popupSlice.hide())}>انصراف</button>
    </span>
    </main>
  )
}
export default BuyReport